import {showNotification} from "@mantine/notifications";
import {
    AiOutlineExclamation,
    AiOutlineInfo,
    AiOutlineLogin
} from "react-icons/ai";
import config from "../config";


export const showErrorNotifications = (e: unknown) => {

    console.debug('handleAppSyncResponseException', e)

    const err = e as { errors?: { message: string }[]; message?: string };
    if (typeof err.errors !== 'undefined' && err.errors.length > 0) {
        err.errors.forEach((error: { message: string; }) => {
            showErrorNotification(error.message);
        })
    } else {
        showErrorNotification(err.message);
    }

}


export const showSuccessNotification = (message = 'Record saved successfully') => {
    showNotification({
                         title: 'Success',
                         icon: <AiOutlineInfo/>,
                         message: message,
                         color: 'teal',
                     })
}

export const showErrorNotification = (message = 'Error performing the operation') => {
    showNotification({
                         title: 'Error',
                         icon: <AiOutlineExclamation/>,
                         message: message,
                         color: 'red',
                     })

    const noCurrentUserMessage = 'no current user'
    if (message.toLowerCase() === noCurrentUserMessage) {
        showSessionExpiredNotification();
    }


}

export const showSessionExpiredNotification = (message = 'Redirecting to network portal...Please, wait!') => {

    showNotification({
                         title: 'Session Expired',
                         icon: <AiOutlineLogin/>,
                         message: message,
                         color: 'blue',
                     });

    setTimeout(() => {
        window.location.assign(config.platform.portal + '/sign-in?returnTo=' +
                                   config.platform.email);
    }, 3000);

};


// notify access denied
export const notifyAccessDenied = (message = 'Access denied') => {
    showNotification({
                         title: 'Access Denied',
                         icon: <AiOutlineExclamation/>,
                         message: message,
                         color: 'red',
                     })
}